export const GET_TAGS = 'GET_TAGS'
export const GET_TAGS_FAILED = 'GET_TAGS_FAILED'
export const GET_TAGS_SUCCEEDED = 'GET_TAGS_SUCCEEDED'

export const CREATE_TAG = 'CREATE_TAG'
export const CREATE_TAG_FAILED = 'CREATE_TAG_FAILED'
export const CREATE_TAG_SUCCEEDED = 'CREATE_TAG_SUCCEEDED'

export const GET_TAG_MAPPINGS = 'GET_TAG_MAPPINGS'
export const GET_TAG_MAPPINGS_FAILED = 'GET_TAG_MAPPINGS_FAILED'
export const GET_TAG_MAPPINGS_SUCCEEDED = 'GET_TAG_MAPPINGS_SUCCEEDED'
